// Libs
import React, { Component } from 'react'
import { Field } from 'redux-form'
import _ from 'lodash'
import { CheckSquare, MinusSquare } from 'react-feather'

// CSS
import "./styles.scss"

// Components
import MyCasesPageFilterField from '../MyCasesPageFilterField'

class MyCasesPageFilterSection extends Component {

  state = {
    checked: false
  }

  handleCheckBoxClick() {
    const { handleSelectAll, handleReset } = this.props
    const { checked } = this.state

    if (checked) {
      handleReset()
    }
    else {
      handleSelectAll()
    }
    this.setState({ checked: !checked })
  }

  render() {
    const { type, name, title, beta, options, sorted, handleReset, filter, handleSelectAll } = this.props
    const { checked } = this.state
    let sortedOptions = options
    let selected = false

    if (sorted) {
      sortedOptions = _.orderBy(options, [options => options.label.toLowerCase()], ['asc'])
    }

    if (filter && filter.values && !_.isEmpty(filter.values[name])) {
      selected = true
    }

    return (
      <div className="my-cases-page-filter-section">
        <div className={type === 'checkbox' ? "my-cases-page-filter-section__header my-cases-page-filter-section__header--checkbox" : "my-cases-page-filter-section__header"}>
          {type === 'checkbox' &&
            <div className='my-cases-page-filter-section__title__checkbox' onClick={() => this.handleCheckBoxClick()}>
              <span style={{ backgroundColor: checked && '#12B7A3' }} />
            </div>
          }
          <div>
            <p className="my-cases-page-filter-section__title" style={{ color: selected && '#12B7A3' }}>{title}</p>
            {beta &&
              <p className="my-cases-page-filter-section__title">BETA</p>
            }
          </div>
          {type !== 'checkbox' && <p className="my-cases-page-filter-section__reset" onClick={handleReset}>limpar</p>}
        </div >
        {
          sortedOptions.map((option, index) => (
            <div key={index}>
              <Field
                index={index}
                component={MyCasesPageFilterField}
                type={type}
                name={name}
                section={title}
                value={type !== 'checkbox' ? option.value : ''}
                option={option}
              />
              {option.subtitle &&
                <p className="my-cases-page-filter-section__subtitle">{option.subtitle}</p>
              }
            </div>
          ))
        }
      </div >
    )
  }
}

export default MyCasesPageFilterSection
